import { PSkeletonTypographyLoader } from '@/components/atoms/Skeleton/PSkeletonTypographyLoader';
import { PTypography } from '@/components/atoms/Typography/PTypography';
import { TypographyLoadingProps } from '@/components/molecules/TypographyLoading/types';

/**
 * TypographyLoading is a Predium design system component molecule for text that supports a loading
 * state.
 *
 * **Important note:** If you need to give strong importance to the text, use the \<strong> HTML5 tag to wrap the
 * text content of this component.
 *
 * @param {Object} props - PreTypographyLoadingProps.
 */
export const PTypographyLoading = ({ children, isLoading, loaderWidth, ...props }: TypographyLoadingProps) => {
  return (
    <PTypography {...props}>
      <PSkeletonTypographyLoader isLoading={isLoading} loaderWidth={loaderWidth}>
        {children}
      </PSkeletonTypographyLoader>
    </PTypography>
  );
};
